import type {
  ContentPatchMessage,
  DesignTokensMessage,
  MediaPatchMessage,
} from '@web-studio/shared-schemas';
import { useSandboxPreviewStore } from '@/previewStore';
import { applyDesignTokens, parseDesignTokens } from '@/utils/themeEngine';

export function handleContentPatchMessage(message: ContentPatchMessage): void {
  useSandboxPreviewStore
    .getState()
    .patchBlockContent(message.blockId, message.key, message.value, message.locale);
}

export function handleMediaPatchMessage(message: MediaPatchMessage): void {
  useSandboxPreviewStore.getState().patchBlockMedia(message.blockId, message.key, message.value);
}

export function handleDesignTokensMessage(message: DesignTokensMessage): void {
  applyDesignTokens(parseDesignTokens(message.design_tokens));
}
